import ViewJobDataContext from './ViewJobDataContext';

import { type PropsWithChildren, useContext } from 'react';

export function isDesktop(viewjobModel: model.viewjob.ViewJobClientSideModel | null | undefined) {
    const rnViewJobDisplay = viewjobModel?.rnViewJobDisplay ?? 'MOBILE_STANDALONE';
    return rnViewJobDisplay === 'DESKTOP_STANDALONE' || rnViewJobDisplay === 'DESKTOP_EMBEDDED';
}

export function useIsMobile() {
    return !useIsDesktop();
}

export function useIsDesktop() {
    return isDesktop(useContext(ViewJobDataContext)?.initialData);
}

const DesktopOnly: React.FC<PropsWithChildren> = ({ children }) => {
    return useIsDesktop() ? <>{children}</> : null;
};

const MobileOnly: React.FC<PropsWithChildren> = ({ children }) => {
    return useIsMobile() ? <>{children}</> : null;
};

export const ScreenDisplay = {
    MobileOnly,
    DesktopOnly,
};
